<template>
  <div class="arc-sec">
    <div class="arc-toolbar">
      <div class="chips">
        <button v-for="s in filtros" :key="s.v" class="chip" :class="{ on: filtro === s.v }" type="button" @click="filtro = s.v">{{ s.l }}</button>
      </div>
      <div class="spacer" />
      <button class="btn primary" type="button" @click="openNew">+ {{ $t('ARC_MGMT.ADD') }}</button>
    </div>
    <div v-if="loading" class="muted">{{ $t('ARC_MGMT.LOADING') }}</div>
    <table v-else>
      <tbody>
        <tr v-for="p in filtered" :key="p.id">
          <td>
            <b>{{ p.titulo }}</b>
            <div class="ctx">{{ p.contexto }} · {{ $t('ARC_MGMT.PENDINGS.DAYS', { n: p.dias_aberta }) }}</div>
          </td>
          <td><span class="tag" :class="p.status">{{ $t('ARC_MGMT.PENDINGS.' + p.status) }}</span></td>
          <td class="acts">
            <button v-if="p.status === 'aberta'" class="link" type="button" @click="resolve(p)">{{ $t('ARC_MGMT.PENDINGS.RESOLVE') }}</button>
            <button class="link danger" type="button" @click="remove(p)">{{ $t('ARC_MGMT.DELETE') }}</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showModal" class="arc-modal-bg" @click.self="showModal = false">
      <div class="arc-modal">
        <h3>{{ $t('ARC_MGMT.PENDINGS.NEW') }}</h3>
        <label>{{ $t('ARC_MGMT.PENDINGS.TITLE') }}<input v-model="item.titulo" type="text" /></label>
        <label>{{ $t('ARC_MGMT.PENDINGS.CONTEXT') }}<textarea v-model="item.contexto" rows="2" /></label>
        <div class="modal-actions">
          <button class="btn" type="button" @click="showModal = false">{{ $t('ARC_MGMT.CANCEL') }}</button>
          <button class="btn primary" type="button" @click="save">{{ $t('ARC_MGMT.SAVE') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ArcAPI from 'dashboard/api/arc';
export default {
  props: { journey: { type: Object, default: () => ({}) } },
  data() { return { items: [], loading: true, filtro: 'aberta', showModal: false, item: {},
    filtros: [{ v: 'aberta', l: 'Abertas' }, { v: 'resolvida', l: 'Resolvidas' }, { v: 'all', l: 'Todas' }] }; },
  computed: { filtered() { return this.filtro === 'all' ? this.items : this.items.filter(p => p.status === this.filtro); } },
  mounted() { this.load(); },
  methods: {
    async load() { this.loading = true; try { const { data } = await ArcAPI.pendingItems(); this.items = data.payload || []; } finally { this.loading = false; } },
    openNew() { this.item = { titulo: '', contexto: '' }; this.showModal = true; },
    async save() { await ArcAPI.createPendingItem(this.item); this.showModal = false; this.load(); this.$emit('refresh'); },
    async resolve(p) { await ArcAPI.resolvePendingItem(p.id); this.load(); this.$emit('refresh'); },
    async remove(p) { if (!window.confirm(this.$t('ARC_MGMT.DELETE') + '?')) return; await ArcAPI.deletePendingItem(p.id); this.load(); },
  },
};
</script>
<style lang="scss" scoped>
.arc-toolbar { display: flex; align-items: center; gap: var(--space-small); margin-bottom: var(--space-normal); }
.spacer { flex: 1; } .chips { display: flex; gap: var(--space-micro); }
.chip { border: 1px solid var(--s-200); background: var(--white); border-radius: 9999px; padding: var(--space-micro) var(--space-small); font-size: var(--font-size-mini); color: var(--s-600); cursor: pointer; &.on { background: var(--s-800); border-color: var(--s-800); color: var(--white); } }
table { width: 100%; border-collapse: collapse; }
td { padding: var(--space-small); border-bottom: 1px solid var(--s-75); font-size: var(--font-size-small); color: var(--s-800); }
.ctx { color: var(--s-500); font-size: var(--font-size-mini); margin-top: var(--space-micro); }
.tag { font-size: var(--font-size-mini); padding: var(--space-micro) var(--space-small); border-radius: 9999px; &.aberta { background: var(--y-100); color: var(--y-700); } &.resolvida { background: var(--g-100); color: var(--g-700); } }
.acts { text-align: right; white-space: nowrap; } .muted { color: var(--s-500); }
.link { border: 0; background: none; color: var(--w-600); font-size: var(--font-size-mini); cursor: pointer; padding: 0 var(--space-smaller); &.danger { color: var(--r-500); } }
.btn { height: var(--space-large); padding: 0 var(--space-normal); border-radius: var(--border-radius-normal); border: 1px solid var(--s-200); background: var(--white); color: var(--s-700); font-weight: var(--font-weight-medium); cursor: pointer; &.primary { background: var(--w-500); border-color: var(--w-500); color: var(--white); } }
.arc-modal-bg { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: grid; place-items: center; z-index: 9999; }
.arc-modal { background: var(--white); border-radius: var(--border-radius-large); padding: var(--space-large); width: 30rem; max-width: 92vw;
  h3 { margin: 0 0 var(--space-normal); color: var(--s-900); } label { display: flex; flex-direction: column; gap: var(--space-smaller); font-size: var(--font-size-small); color: var(--s-700); margin-bottom: var(--space-small); }
  input, textarea { border: 1px solid var(--s-200); border-radius: var(--border-radius-normal); padding: var(--space-smaller) var(--space-small); background: var(--white); color: var(--s-800); } }
.modal-actions { display: flex; justify-content: flex-end; gap: var(--space-small); margin-top: var(--space-normal); }
</style>
